module.exports = __webpack_public_path__ + "img/ground_4.54a8d04c.png";